import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAtom, faChartLine, faLayerGroup } from '@fortawesome/free-solid-svg-icons';

const ProteomicsReport = ({ id, type, data }) => {
    // Placeholder data
    const proteomicsData = data || {
        summary: {
            totalProteins: 1248,
            significantChanges: 87,
            upregulated: 52,
            downregulated: 35
        },
        topProteins: [
            { name: 'Albumin', abundance: 42.3, change: '+1.2', significance: 'High' },
            { name: 'Transferrin', abundance: 28.7, change: '-0.8', significance: 'Medium' },
            { name: 'Immunoglobulin G', abundance: 15.2, change: '+2.4', significance: 'High' },
            { name: 'C-Reactive Protein', abundance: 0.8, change: '+3.7', significance: 'High' },
            { name: 'Apolipoprotein A1', abundance: 12.5, change: '-1.5', significance: 'Medium' }
        ],
        pathwayAnalysis: [
            { pathway: 'Inflammatory Response', enrichment: 3.8, proteins: 12 },
            { pathway: 'Lipid Transport', enrichment: 2.9, proteins: 8 },
            { pathway: 'Complement Activation', enrichment: 2.7, proteins: 9 },
            { pathway: 'Cell Adhesion', enrichment: 2.1, proteins: 7 },
            { pathway: 'Immune Response', enrichment: 1.9, proteins: 15 }
        ]
    };

    return (
        <div className="OmicsView-proteomics-report">
            <h3>Proteomics Report for {id}</h3>
            <div className="OmicsView-proteomics-content">
                <div className="OmicsView-proteomics-section">
                    <h4>
                        <FontAwesomeIcon icon={faAtom} /> Protein Profile Summary
                    </h4>
                    <div className="OmicsView-proteomics-summary">
                        <div className="OmicsView-proteomics-summary-item">
                            <div className="OmicsView-proteomics-summary-value">
                                {proteomicsData.summary.totalProteins}
                            </div>
                            <div className="OmicsView-proteomics-summary-label">
                                Total Proteins Detected
                            </div>
                        </div>
                        <div className="OmicsView-proteomics-summary-item">
                            <div className="OmicsView-proteomics-summary-value highlight">
                                {proteomicsData.summary.significantChanges}
                            </div>
                            <div className="OmicsView-proteomics-summary-label">
                                Significant Changes
                            </div>
                        </div>
                        <div className="OmicsView-proteomics-summary-item">
                            <div className="OmicsView-proteomics-summary-value up">
                                {proteomicsData.summary.upregulated}
                            </div>
                            <div className="OmicsView-proteomics-summary-label">
                                Upregulated
                            </div>
                        </div>
                        <div className="OmicsView-proteomics-summary-item">
                            <div className="OmicsView-proteomics-summary-value down">
                                {proteomicsData.summary.downregulated}
                            </div>
                            <div className="OmicsView-proteomics-summary-label">
                                Downregulated
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="OmicsView-proteomics-section">
                    <h4>
                        <FontAwesomeIcon icon={faChartLine} /> Top Abundant Proteins
                    </h4>
                    <div className="OmicsView-proteomics-proteins">
                        <table className="OmicsView-proteomics-table">
                            <thead>
                                <tr>
                                    <th>Protein</th>
                                    <th>Relative Abundance (%)</th>
                                    <th>Change</th>
                                    <th>Significance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {proteomicsData.topProteins.map((protein, index) => (
                                    <tr key={index}>
                                        <td>{protein.name}</td>
                                        <td>
                                            <div className="OmicsView-proteomics-abundance-bar-container">
                                                <div 
                                                    className="OmicsView-proteomics-abundance-bar"
                                                    style={{ width: `${protein.abundance * 2}%` }}
                                                ></div>
                                                <span>{protein.abundance.toFixed(1)}%</span>
                                            </div>
                                        </td>
                                        <td className={protein.change.startsWith('+') ? 'up' : 'down'}>
                                            {protein.change}
                                        </td>
                                        <td>
                                            <span className={`significance-${protein.significance.toLowerCase()}`}>
                                                {protein.significance}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <div className="OmicsView-proteomics-section">
                    <h4>
                        <FontAwesomeIcon icon={faLayerGroup} /> Pathway Analysis
                    </h4>
                    <div className="OmicsView-proteomics-pathways">
                        {proteomicsData.pathwayAnalysis.map((pathway, index) => (
                            <div key={index} className="OmicsView-proteomics-pathway">
                                <div className="OmicsView-proteomics-pathway-name">
                                    {pathway.pathway}
                                </div>
                                <div className="OmicsView-proteomics-pathway-bar-container">
                                    <div 
                                        className="OmicsView-proteomics-pathway-bar"
                                        style={{ width: `${Math.min(100, pathway.enrichment * 20)}%` }}
                                    ></div>
                                </div>
                                <div className="OmicsView-proteomics-pathway-details">
                                    Enrichment: {pathway.enrichment.toFixed(1)} | {pathway.proteins} proteins
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProteomicsReport;
